import React, { useContext, useEffect, useState } from 'react';
import { MaxContext } from './context';
import { subPageSetterMapping } from '.';

export const SubPage = (_props: any) => {
  const { pageCode } = useContext(MaxContext);

  const { debugCode, props = {} } = _props;
  const { style, ref: previewRef } = props;

  const [subPageInstance, setSubPageInstance] = useState<any>(null);

  useEffect(() => {
    subPageSetterMapping.set(pageCode, setSubPageInstance);

    return () => {
      subPageSetterMapping.delete(pageCode);
    };
  }, []);

  return (
    <div style={style} className="max-render-sub-page" id={pageCode} ref={previewRef} data-debugcode={debugCode}>
      {subPageInstance}
    </div>
  );
};
